import React, { useState } from "react";
import styles from "./Tools.module.css";
import CryptoJS from "crypto-js";

const RIPEMD = () => {
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState("");
  const [inputType, setInputType] = useState("hex");

  const generateHash = async () => {
    try {
      let hashHex = null;
      if (inputType === "text") {
        hashHex = CryptoJS.RIPEMD160(inputValue).toString(CryptoJS.enc.Hex);
      }
      else if (inputType === "hex"){
        let wordArray = CryptoJS.enc.Hex.parse(inputValue);
        hashHex = CryptoJS.RIPEMD160(wordArray).toString(CryptoJS.enc.Hex);
      }
      setResult(hashHex);
    } catch (error) {
      setResult(`Error: ${error.message}`);
    }
  };

  return (
    <div className={`${styles.tools} times mbox`}>
        <h4 className="text-center" title="Generate RIPEMD-160 hash (20 bytes) for text or hex string">
        <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
        Generate RIPEMD-160 Hash
        </h4>
        <hr />
            <table width="100%">
                <tbody>
                <tr style={{ height: 90 }}>
                <td>
                    <div className={`${styles.enterHex}`}>Enter String Value: </div>
                    <div width="100%">
                    <input
                        type="text"
                        id="mdinputValue"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                        placeholder="Enter text or hex string"
                        />
                    </div>
                    <div>
                        <label htmlFor="mdhashType" style={{ marginRight: "4px"}}>Input String Format: </label>
                          <select
                            id="mdhashType"
                            value={inputType}
                            onChange={(e) => setInputType(e.target.value)}
                            style={{ padding: "8px", marginTop: "5px" }}
                            >
                            <option value="text">Text String</option>
                            <option value="hex">Hex String</option>
                        </select>
                      </div>
                </td>
                </tr>
                <tr style={{ height: 60 }}>
                    <td>
                        <div>
                            <button className="btn btn-primary" title="Generate RIPEMD-160 hash (20 bytes) for the input string" onClick={generateHash}>Generate Hash</button>
                        </div>
                    </td>
                </tr>
                <tr style={{ height: 90 }}>
                <td>
                    <div className="label">Hash Value: </div>
                    <div width="100%">
                    <input
                        id="mdResult"
                        readOnly={true}
                        type="text"
                        style={{ width: "100%", padding: "8px", marginTop: "5px", backgroundColor: "lightgray" }}
                        value={result}
                        />
                    </div>
                </td>
                </tr>
                </tbody>
            </table>
    </div>
  );
};

export default RIPEMD;
